import {
    faArrowUpRightFromSquare,
    faBriefcase,
    faChartSimple,
    faCheckCircle,
    faCircleExclamation,
    faCirclePlay,
    faCircleXmark,
    faEye,
    faFileExport,
    faFlask,
    faGear,
    faInfoCircle,
    faPenToSquare,
    faPlay,
    faPlus,
    faRotateLeft,
    faSignOut,
    faStop,
    faTemperatureHalf,
    faTrashCan,
    faVials,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export type IconProps = Omit<FontAwesomeIconProps, "icon">;

export const ArrowUpRightFromSquareIcon = (props: IconProps) => (
    <FontAwesomeIcon {...props} icon={faArrowUpRightFromSquare} />
);
export const PenToSquareIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faPenToSquare} />;
export const SignOutIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faSignOut} />;
export const TemperatureHalfIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faTemperatureHalf} />;
export const FlaskIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faFlask} />;
export const InfoCircleIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faInfoCircle} />;
export const CirclePlayIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faCirclePlay} />;
export const PlayIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faPlay} />;
export const StopIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faStop} />;
export const TrashCanIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faTrashCan} />;
export const CheckCircleIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faCheckCircle} />;
export const CircleExclamationIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faCircleExclamation} />;
export const CircleXmarkIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faCircleXmark} />;
export const ChartSimpleIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faChartSimple} />;
export const FileExportIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faFileExport} />;
export const CompositionIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faVials} />;
export const GearIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faGear} />;
export const XmarkIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faXmark} />;
export const RotateLeftIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faRotateLeft} />;
export const BriefcaseIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faBriefcase} />;
export const EyeIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faEye} />;
export const PlusIcon = (props: IconProps) => <FontAwesomeIcon {...props} icon={faPlus} />;
